// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
'use client';
import React from 'react';
import useBaseComponent from '../internal/hooks/use-base-component';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import { getExternalProps } from '../internal/utils/external-props';
import InternalColumnLayout from './internal';
export default function ColumnLayout({ columns = 1, variant = 'default', borders = 'none', disableGutters = false, ...props }) {
    const baseComponentProps = useBaseComponent('ColumnLayout', {
        props: { borders, columns, disableGutters, minColumnWidth: props.minColumnWidth, variant },
    });
    const externalProps = getExternalProps(props);
    return (React.createElement(InternalColumnLayout, { columns: columns, variant: variant, borders: borders, disableGutters: disableGutters, ...externalProps, ...baseComponentProps }));
}
applyDisplayName(ColumnLayout, 'ColumnLayout');
//# sourceMappingURL=index.js.map